document.addEventListener('DOMContentLoaded', () => {

  // Alphabet Filter
  document.querySelectorAll('.alphabet-item').forEach(btn => {
    btn.addEventListener('click', () => {
      const letter = btn.dataset.letter;

      document.querySelectorAll('.ingredient-card').forEach(card => {
        card.style.display =
          card.dataset.letter === letter ? 'block' : 'none';
      });

      document.querySelectorAll('.alphabet-item')
        .forEach(b => b.classList.remove('active'));

      btn.classList.add('active');
    });
  });

  
  const modal = document.getElementById('ingredientModal');

document.querySelectorAll('.ingredient-plus').forEach(btn => {
  btn.addEventListener('click', () => {
    modal.classList.add('active');

    document.getElementById('modalTitle').textContent = btn.dataset.name;
    document.getElementById('modalImage').src = btn.dataset.image;
    document.getElementById('modalDescription').innerHTML = btn.dataset.description;

    const tags = btn.dataset.tags.split(',');
    document.getElementById('modalTags').innerHTML =
      tags.map(tag => `<span class="tag">${tag}</span>`).join('');
  });
});

document.querySelector('.modal-close').addEventListener('click', () => {
  modal.classList.remove('active');
});

modal.addEventListener('click', e => {
  if (e.target === modal) modal.classList.remove('active');
});


});
